(() => {
  const TEST_ID = 'cart_email_v1';
  const DISCOUNT_CODE = 'YURCHAK10';
  const VARIANT_KEY = 'yurchak_cart_email_variant';
  const SHOWN_KEY = 'yurchak_cart_email_shown';
  const CAPTURED_KEY = 'yurchak_cart_email_captured';
  const FIRST_ADD_KEY = 'yurchak_cart_email_first_add_tracked';
  const CAPTURE_ID_KEY = 'yurchak_cart_capture_id';

  const variants = {
    A: {
      title: 'DON’T LOSE YOUR CART',
      body: 'We know you’re busy — and sometimes you just need time to think. Leave your email so we can save your cart and keep you posted on special offers.',
      cta: 'SAVE MY CART'
    },
    B: {
      title: 'WANT A BETTER DEAL?',
      body: 'Leave your email and we’ll let you know about special offers for your cart.',
      cta: 'KEEP ME POSTED'
    },
    C: {
      title: 'GET 10% OFF YOUR FIRST ORDER',
      body: 'Leave your email to get 10% off your first YURCHAK order.',
      cta: 'GET 10% OFF'
    }
  };

  const store = {
    get(key) {
      try { return localStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { localStorage.setItem(key, value); } catch (e) {}
    },
    remove(key) {
      try { localStorage.removeItem(key); } catch (e) {}
    }
  };

  function claritySet(key, value) {
    if (typeof window.clarity === 'function') window.clarity('set', key, String(value));
  }

  function clarityEvent(name) {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  function event(base, variant) {
    clarityEvent(base);
    clarityEvent(base + '_' + variant);
  }

  function resetIfRequested() {
    const params = new URLSearchParams(location.search);
    if (params.get('y_ab_reset') === '1') {
      store.remove(VARIANT_KEY);
      store.remove(SHOWN_KEY);
      store.remove(CAPTURED_KEY);
      store.remove(FIRST_ADD_KEY);
      store.remove(CAPTURE_ID_KEY);
    }
  }

  function assignVariant() {
    const params = new URLSearchParams(location.search);
    const forced = (params.get('y_ab_variant') || '').toUpperCase();

    if (variants[forced]) {
      store.set(VARIANT_KEY, forced);
      return forced;
    }

    const saved = store.get(VARIANT_KEY);
    if (variants[saved]) return saved;

    const keys = Object.keys(variants);
    const assigned = keys[Math.floor(Math.random() * keys.length)];
    store.set(VARIANT_KEY, assigned);
    return assigned;
  }

  function captureId() {
    const saved = store.get(CAPTURE_ID_KEY);
    if (saved) return saved;
    const value = typeof window.crypto?.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : 'cap_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
    store.set(CAPTURE_ID_KEY, value);
    return value;
  }

  function updateCartAttributes(attributes) {
    const payload = {
      _yurchak_ab_test: TEST_ID,
      ...attributes,
      yurchak_ab_test: '',
      yurchak_ab_variant: '',
      yurchak_ab_discount: '',
      yurchak_cart_email: '',
      yurchak_cart_token: '',
      yurchak_cart_items: ''
    };

    if (window.YurchakCartCore?.updateCart) {
      return window.YurchakCartCore.updateCart({ attributes: payload });
    }

    return fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: payload })
    }).then(async response => {
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data?.status) throw new Error(data?.description || 'cart_attribute_update_failed');
      return data;
    });
  }

  function saveVariantToCart(variant) {
    updateCartAttributes({ _yurchak_ab_variant: variant }).catch(() => {});
  }

  async function linkCaptureToCart(id, variant) {
    await updateCartAttributes({
      _yurchak_ab_variant: variant,
      _yurchak_ab_capture_id: id,
      _yurchak_ab_discount: variant === 'C' ? DISCOUNT_CODE : ''
    });
    claritySet('y_ab_cart_linked', 'yes');
    event('y_ab_cart_link_success', variant);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const copied = document.execCommand('copy');
        textarea.remove();
        copied ? resolve() : reject(new Error('copy_failed'));
      } catch (error) {
        textarea.remove();
        reject(error);
      }
    });
  }

  function injectStyles() {
    if (document.getElementById('yurchak-ab-styles')) return;

    const style = document.createElement('style');
    style.id = 'yurchak-ab-styles';
    style.textContent = [
      '.yurchak-ab-dialog{border:0;padding:0;background:transparent;max-width:none;max-height:none}',
      '.yurchak-ab-dialog::backdrop{background:rgba(0,0,0,.46);backdrop-filter:blur(3px)}',
      '.yurchak-ab-card{position:relative;width:min(92vw,520px);background:#fff;color:#000;padding:34px 32px 28px;box-shadow:0 24px 70px rgba(0,0,0,.25)}',
      '.yurchak-ab-close{position:absolute;top:10px;right:12px;border:0;background:transparent;font-size:30px;line-height:1;cursor:pointer;padding:6px;color:#000}',
      '.yurchak-ab-title{margin:0 42px 12px 0;font-size:clamp(24px,4vw,34px);line-height:1.04;font-weight:700;letter-spacing:-.02em}',
      '.yurchak-ab-copy{margin:0 0 22px;font-size:15px;line-height:1.5;color:rgba(0,0,0,.72)}',
      '.yurchak-ab-form{display:grid;grid-template-columns:1fr auto;gap:10px}',
      '.yurchak-ab-form.is-complete{grid-template-columns:1fr}',
      '.yurchak-ab-form.is-complete .yurchak-ab-input{display:none}',
      '.yurchak-ab-form.is-complete .yurchak-ab-submit{width:100%}',
      '.yurchak-ab-input{height:50px;min-width:0;border:1px solid #000;background:#fff;color:#000;padding:0 14px;font:inherit;border-radius:0}',
      '.yurchak-ab-submit{height:50px;border:1px solid #000;background:#000;color:#fff;padding:0 20px;font:inherit;font-weight:700;cursor:pointer;border-radius:0;white-space:nowrap}',
      '.yurchak-ab-submit[disabled]{opacity:.6;cursor:wait}',
      '.yurchak-ab-note{margin:10px 0 0;font-size:12px;line-height:1.35;color:rgba(0,0,0,.5)}',
      '.yurchak-ab-status{margin:12px 0 0;min-height:18px;font-size:13px;line-height:1.4}',
      '.yurchak-ab-status[data-state="error"]{color:#a40000}',
      '.yurchak-ab-status[data-state="success"]{font-weight:600}',
      '.yurchak-ab-code{display:inline-block;margin-left:4px;font-weight:800;letter-spacing:.08em}',
      '@media(max-width:600px){.yurchak-ab-card{width:min(92vw,430px);padding:30px 20px 22px}.yurchak-ab-form{grid-template-columns:1fr}.yurchak-ab-submit{width:100%}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createDialog(variant) {
    injectStyles();
    const copy = variants[variant];

    const dialog = document.createElement('dialog');
    dialog.className = 'yurchak-ab-dialog';
    dialog.setAttribute('aria-labelledby', 'yurchak-ab-title');
    dialog.setAttribute('aria-describedby', 'yurchak-ab-copy');

    dialog.innerHTML =
      '<div class="yurchak-ab-card">' +
        '<button type="button" class="yurchak-ab-close" aria-label="Close">×</button>' +
        '<h2 id="yurchak-ab-title" class="yurchak-ab-title"></h2>' +
        '<p id="yurchak-ab-copy" class="yurchak-ab-copy"></p>' +
        '<form class="yurchak-ab-form" novalidate>' +
          '<input class="yurchak-ab-input" type="email" name="email" autocomplete="email" inputmode="email" placeholder="Email address" aria-label="Email address" required>' +
          '<button class="yurchak-ab-submit" type="submit"></button>' +
        '</form>' +
        '<p class="yurchak-ab-note">No pressure — close this window to keep shopping.</p>' +
        '<p class="yurchak-ab-status" role="status" aria-live="polite"></p>' +
      '</div>';

    dialog.querySelector('.yurchak-ab-title').textContent = copy.title;
    dialog.querySelector('.yurchak-ab-copy').textContent = copy.body;
    dialog.querySelector('.yurchak-ab-submit').textContent = copy.cta;

    return dialog;
  }

  async function submitEmail(email, variant, status, button) {
    event('y_ab_email_submit', variant);
    claritySet('y_ab_email_submit', 'yes');

    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'SAVING…';
    status.textContent = '';
    status.dataset.state = '';

    const id = captureId();
    const body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[tags]', 'newsletter,' + TEST_ID + ',variant_' + variant.toLowerCase() + ',capture_' + id);

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        redirect: 'follow',
        body: body.toString()
      });

      if (!response.ok) throw new Error('newsletter_signup_failed');

      let cartLinked = true;
      try {
        await linkCaptureToCart(id, variant);
      } catch (cartError) {
        cartLinked = false;
        claritySet('y_ab_cart_linked', 'no');
        event('y_ab_cart_link_error', variant);
      }

      store.set(CAPTURED_KEY, '1');
      claritySet('y_ab_email_captured', 'yes');
      event('y_ab_email_success', variant);

      status.dataset.state = 'success';

      if (variant === 'C') {
        const form = button.closest('form');
        if (form) form.classList.add('is-complete');

        status.innerHTML = 'Thanks — your 10% first-order code is <span class="yurchak-ab-code">' + DISCOUNT_CODE + '</span>. Enter this email at checkout.';
        claritySet('y_ab_discount_code', DISCOUNT_CODE);
        event('y_ab_discount_revealed', variant);

        button.disabled = false;
        button.type = 'button';
        button.textContent = 'COPY ' + DISCOUNT_CODE;

        button.onclick = () => {
          copyText(DISCOUNT_CODE)
            .then(() => {
              status.innerHTML = 'Copied — use <span class="yurchak-ab-code">' + DISCOUNT_CODE + '</span> at checkout.';
              event('y_ab_discount_copy', variant);
            })
            .catch(() => {
              status.innerHTML = 'Your code is <span class="yurchak-ab-code">' + DISCOUNT_CODE + '</span>. Enter it at checkout.';
            });
        };
        return;
      }

      status.textContent = cartLinked
        ? 'Thanks — your email and cart have been saved.'
        : 'Your email was saved, but we could not attach it to this cart. You can continue shopping.';
      status.dataset.state = cartLinked ? 'success' : 'partial';
      button.textContent = 'DONE';

      setTimeout(() => {
        const activeDialog = button.closest('dialog');
        if (activeDialog && activeDialog.open) activeDialog.close('success');
      }, 900);
    } catch (error) {
      event('y_ab_email_error', variant);
      status.dataset.state = 'error';
      status.textContent = 'Something went wrong. Please try again.';
      button.disabled = false;
      button.textContent = original;
    }
  }

  function showPopup(meta) {
    const variant = assignVariant();
    const dialog = createDialog(variant);
    const closeButton = dialog.querySelector('.yurchak-ab-close');
    const form = dialog.querySelector('.yurchak-ab-form');
    const input = dialog.querySelector('.yurchak-ab-input');
    const button = dialog.querySelector('.yurchak-ab-submit');
    const status = dialog.querySelector('.yurchak-ab-status');

    claritySet('y_ab_test', TEST_ID);
    claritySet('y_ab_variant', variant);
    claritySet('y_ab_popup_seen', 'yes');

    if (meta && meta.productVariantId) claritySet('y_ab_product_variant', meta.productVariantId);
    claritySet('y_ab_entry_path', location.pathname);

    event('y_ab_popup_impression', variant);

    function close(reason) {
      if (!dialog.open) return;
      claritySet('y_ab_popup_closed', reason);
      event('y_ab_popup_close', variant);
      dialog.close(reason);
    }

    closeButton.addEventListener('click', () => close('close_button'));
    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      close('escape');
    });
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) close('backdrop');
    });
    dialog.addEventListener('close', () => dialog.remove());

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!input.checkValidity()) {
        input.reportValidity();
        event('y_ab_email_invalid', variant);
        return;
      }
      submitEmail(input.value.trim(), variant, status, button);
    });

    document.body.appendChild(dialog);
    dialog.showModal();
    setTimeout(() => input.focus(), 60);
  }

  function onCartUpdate(data) {
    const meta = data?.detail || data || {};
    const source = String(meta.source || '').toLowerCase();
    const productVariantId = Number(meta.productVariantId || meta.variantId || meta.product_variant_id || 0);
    const explicitAddEvent = meta.action === 'item-added';
    const supportedAddSource = /^(product-form|quick-add|yurchak-(shop-card|shop-card-size|recommendations|cart-recommendations|complete-look|complete-look-modal)|featured.*)$/.test(source);

    if (!productVariantId) return;
    if (!explicitAddEvent || !supportedAddSource) return;
    if (/express|gift|bogos|quantity|change|remove|discount/.test(source)) return;
    if (store.get(FIRST_ADD_KEY) === '1') return;

    store.set(FIRST_ADD_KEY, '1');
    const variant = assignVariant();

    claritySet('y_ab_test', TEST_ID);
    claritySet('y_ab_variant', variant);
    event('y_ab_first_cart_add', variant);
    saveVariantToCart(variant);

    if (store.get(CAPTURED_KEY) === '1') return;
    if (store.get(SHOWN_KEY) === '1') return;

    store.set(SHOWN_KEY, '1');
    showPopup({ ...meta, productVariantId });
  }

  function bindCheckoutIntent() {
    document.addEventListener('click', (e) => {
      const target = e.target.closest('a[href*="/checkout"],button[name="checkout"],input[name="checkout"]');
      if (!target) return;

      const variant = assignVariant();
      claritySet('y_ab_checkout_intent', 'yes');
      event('y_ab_checkout_intent', variant);
    }, true);
  }

  resetIfRequested();
  const assigned = assignVariant();
  claritySet('y_ab_test', TEST_ID);
  claritySet('y_ab_variant', assigned);

  document.addEventListener('DOMContentLoaded', () => {
    bindCheckoutIntent();
    document.addEventListener('yurchak:cart-updated', onCartUpdate);
  });
})();